import React from 'react';


class Decode extends React.Component {
	
    componentDidMount = () => {
    }
	
    componentDidUpdate = () => {
    }
	
	renderContent = () => {

	}

	render = () => {

        //console.log('props', this.props); onClick={this.props.onCalculate}

		return (
			<div className={"decoding container column center"}>
				<h2 className={"h2margin"}>Расшифровка позиций</h2>
				<div className={"decoding__info container column"}>
					<p><b>В вашем Коде Жизни:</b></p>
					<p>п.1 - наше Предназначение, наш архетип и наша сильная ресурсная позиция.</p>
					<p>п.2 - Урок жизни, не пройденный урок прошлого воплощения и структура характера.</p>
					<p>п.3 - Энергия экзаменатор. Никогда не бывает однозначно + или -. Всегда задаёт вопросы и полностью отдаёт ответственность за жизнь человеку в руки.</p>
					<p>п.4 - самая сложная и проблематичная позиция нашего Кода Жизни. Это карма прошлого, наша ТЕНЬ. Это травма детства и голос внутреннего родителя и критики, это наши страхи и наши «грабли».</p>
					<p>п.5 - наша маска или лучшее платье/костюм в зависимости от того, что мы выбираем, жить или играть.</p>
					<p>п.6 - наш талант, тема жизни и сценарий жизни.</p>
					<p>п.7 - миссия/лжемиссия, то, что мы должны наработать в этой жизни.</p>
					<p>п.8 - ангельская помощь, помощь Высшего Я, Бога, ангелов.</p>
					<p>п.9 - кем был в прошлой жизни.</p>
					<p>п.10 - что сделал.</p>
					<p>п.11 - кармическая задача, трансформация.</p>
					<p>п.12 - зона комфорта. Это то, к чему стремимся, то, чего будет нам всегда не хватать.</p>
				</div>
				<div className={"decoding__action container column center"}>
					<h3>Хотите знать больше?</h3>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.171 512.171" fill="red" width="150px"><g><path d="M479.046,283.925c-1.664-3.989-5.547-6.592-9.856-6.592H352.305V10.667C352.305,4.779,347.526,0,341.638,0H170.971 c-5.888,0-10.667,4.779-10.667,10.667v266.667H42.971c-4.309,0-8.192,2.603-9.856,6.571c-1.643,3.989-0.747,8.576,2.304,11.627 l212.8,213.504c2.005,2.005,4.715,3.136,7.552,3.136s5.547-1.131,7.552-3.115l213.419-213.504 C479.793,292.501,480.71,287.915,479.046,283.925z" stroke="black" strokeWidth="5" /></g></svg>
					{/* <a href="/Metodichka_KOD_ZhIZNI.pdf" className={"button button--red "} target="_blank" rel="noopener noreferrer">Скачать</a> */}
					<a href="https://nymerologyschool.ru/lifecodemethod" className={"button button--red "} target="_blank" rel="noopener noreferrer">Скачать</a>
					<div></div>
					
				</div>
				<div style={{paddingTop: '25px'}}>
					<button className={"decoding_new"} onClick={this.props.onReset}>Рассчитать заново</button>
				</div>
			</div>
		);
	}

}

export default Decode;
